import HeroSlider from "../components/Home/HeroSlider";
import MenuOffer from "../components/MenuOffer/MenuOffer";
import styles from "../styles/Home.module.css"
import WrapComponentMenu from "../components/Menu/WrapComponentMenu";
import CustomerReviews from "../components/CustomerReviews/CustomerReviews";
import AlbumComponent from "../components/Album/Abum";
import {useNavigate} from "react-router-dom";
import AboutUsComponent from "../components/AboutUs/AboutUs";
import React from "react";
import {onlineLink} from "../layouts/Header/Header";

const logo = "/assets/logo/logo.png"; // Logo Smoke Lounge

export default function Home() {
    const sectionImg = "assets/imgs/home/home (6).jpg"
    const navigate = useNavigate();

    const handleClick = () => {
        window.scrollTo(0, 0)
        navigate('/tisch-reservieren');
    }
    const handleOpenLink = () => {
        const href = onlineLink;
        if (href === "#") {
            alert("Update folgt in Kürze");
        } else {
            window.location.href = href;
        }
    }
    return <div>
        <HeroSlider handleClick={handleClick}/>
        <MenuOffer subtitle={"Unsere Empfehlungen"} title={"Speisekarte"} desccription={""}/>
        <WrapComponentMenu handleOpenLink={handleOpenLink} isHome={true} handleClick={handleClick}/>
        <MenuOffer subtitle={"Kundenfeedback"} title={"Was Kunden sagen, die in unserem Restaurant gegessen haben"}
                   desccription={""}/>
        <CustomerReviews/>
        <div className={styles.sectionImage}>
            <div className={styles.logoOverlay}>
                <img src={logo} alt="GIRI Logo" className={styles.logo}/>
            </div>
            <img src={sectionImg} alt=""/>
        </div>
        <div  id={"about-us"}>
            <MenuOffer subtitle={"Über uns"} title={"Die Geschichte von GIRI"} desccription={""}/>
        </div>
        <AboutUsComponent handleClick={handleClick}/>
        <MenuOffer subtitle={"GALERIE"} title={"Unser Social Feed"} desccription={""}/>
        <AlbumComponent handleClick={handleClick} handleOpenLink={handleOpenLink}/>
    </div>;
}